module.exports = __webpack_public_path__ + "img/calendar2-month-fill.b6aa3882.svg";